<div class="headings">
    <span class="hr"></span>
    <h1>Governorates</h1>
    <span class="hr"></span>
</div>
<div class="row">
    <app-governert-card class="col-sm-4" *ngFor="let location of governerates" [governart]="location"></app-governert-card>
</div>